export default {"src":"/portal/_next/static/media/sale-banner-blue.fd1cd535.svg","height":113,"width":113,"blurWidth":0,"blurHeight":0};